import { render, staticRenderFns } from "./promisePolitics.vue?vue&type=template&id=a381777a"
import script from "./promisePolitics.vue?vue&type=script&lang=js"
export * from "./promisePolitics.vue?vue&type=script&lang=js"
import style0 from "./promisePolitics.vue?vue&type=style&index=0&id=a381777a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports